export default __webpack_public_path__ + "static/media/img-egt.e4dac284.png";